export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

type Options = RequestInit & { token?: string };

async function request<T>(path: string, options: Options = {}): Promise<T> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options.headers as Record<string, string> | undefined || {}),
  };
  if (options.token) {
    headers['Authorization'] = `Bearer ${options.token}`;
  }
  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const message = (data && typeof data === 'object' && 'message' in data) ? (data as any).message : res.statusText;
    const err: any = new Error(message || 'Request failed');
    if (data && typeof data === 'object' && 'error' in data) err.code = (data as any).error;
    throw err;
  }
  return data as T;
}

export const api = {
  get: <T>(path: string, token?: string) => request<T>(path, { method: 'GET', token }),
  post: <T>(path: string, body?: unknown, token?: string) => request<T>(path, { method: 'POST', body: JSON.stringify(body || {}), token }),
};

export type AccessResponse = { ok: boolean; accessToken: string; refreshToken: string };
export type InventoryItem = { itemId: string; name: string; qty: number };
export type Achievement = { key: string; earnedAt: string };
export type MeUser = { id: string; username: string; email: string; balance?: number; sustainabilityScore?: number; inventory?: InventoryItem[]; achievements?: Achievement[] };
export type MeResponse = { ok: boolean; user: MeUser };